import { render, staticRenderFns } from "./AppDetail.vue?vue&type=template&id=987455b0"
import script from "./AppDetail.vue?vue&type=script&lang=js"
export * from "./AppDetail.vue?vue&type=script&lang=js"
import style0 from "./AppDetail.vue?vue&type=style&index=0&id=987455b0&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports